module.exports = __webpack_public_path__ + "img/googlereviewsp5.c4d1f74a.png";